import { createAccessControl } from "better-auth/plugins/access";
import {
  adminAc,
  defaultStatements,
  memberAc,
  ownerAc,
} from "better-auth/plugins/organization/access";

/**
 * Organization roles for Better Auth's organization plugin. Used by the
 * backend (server plugin) and the frontend (client plugin) so both agree on
 * which roles exist. App-level permissions live in `domain/roles.ts`.
 */
export const ac = createAccessControl(defaultStatements);

export const roles = {
  owner: ac.newRole(ownerAc.statements),
  admin: ac.newRole(adminAc.statements),
  editor: ac.newRole(memberAc.statements),
  viewer: ac.newRole(memberAc.statements),
};
